Retorna usuários da organização que podem ser referenciados como alvos de transferência na API pública.

Usuários inativos também aparecem para que sistemas externos conciliem ids e disponibilidade operacional sem perder referências históricas.

<ApiCodeExamples exampleId="usersList" />

<ApiResponseExamples exampleId="usersList" />

## Escopo obrigatório

- `users.read`

## Endpoints

- `GET /public/v1/users/`: lista paginada.
- `GET /public/v1/users/{id}/`: detalhe de um usuário.

O detalhe usa o mesmo formato de campo do item da lista.

## Query parameters

- `page` (`integer`, opcional): número da página.
- `page_size` (`integer`, opcional): quantidade de itens por página. Default `25`, máximo `100`.
- `search` (`string`, opcional): busca por nome, sobrenome e email.
- `ordering` (`string`, opcional): `email`, `first_name`, `last_name`, `last_login`, `telephony_availability_updated_at`, ou os mesmos campos com prefixo `-`.
- `transfer_eligible` (`boolean`, opcional): `true` para usuários ativos com endpoint elegível, `false` para usuários que não podem receber transferência agora.

## Campos de resposta

- `id` (`uuid`): id público do usuário para `transfer_target.id`.
- `name` (`string`): nome exibível.
- `email` (`string`): email do usuário.
- `is_active` (`boolean`): indica se a conta está ativa.
- `transfer_eligible` (`boolean`): indica se o usuário pode ser usado como alvo de transferência agora.
- `telephony_endpoint` (`object|null`): endpoint ativo e elegível selecionado para exibição.
- `telephony_endpoint.id` (`uuid`): id público do endpoint.
- `telephony_endpoint.endpoint_type` (`string`): tipo do endpoint.
- `telephony_endpoint.extension` (`string|null`): ramal interno, quando existir.
- `telephony_endpoint.external_phone_e164` (`string|null`): telefone externo, quando existir.
- `last_login_at` (`datetime|null`): último login do usuário.
- `updated_at` (`datetime|null`): última atualização de disponibilidade telefônica usada por este catálogo.

## Referência de opções

- `telephony_endpoint.endpoint_type`: `internal_extension` ou `external_extension`.
- `transfer_eligible=true` exige usuário ativo e endpoint de transferência ativo/elegível.

## Erros esperados

- `401 Unauthorized`: token inválido, expirado, revogado, ausente ou bloqueado por IP.
- `403 Forbidden`: a credencial não possui `users.read`.
- `404 Not Found`: o id do detalhe não está disponível para a organização.
- `429 Too Many Requests`: rate limit da credencial excedido.
